/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteVariableResponse } from '../model';
// @ts-ignore
import { GetExportVariablesResponse } from '../model';
// @ts-ignore
import { GetUnassignedVariablesResponse } from '../model';
// @ts-ignore
import { GetVariablesResponse } from '../model';
// @ts-ignore
import { PostImportVariableRequest } from '../model';
// @ts-ignore
import { PostVariableRequest } from '../model';
// @ts-ignore
import { PostVariableResponse } from '../model';
// @ts-ignore
import { PutRemoveVariableResponse } from '../model';
// @ts-ignore
import { PutVariableRequest } from '../model';
// @ts-ignore
import { PutVariableResponse } from '../model';
// @ts-ignore
import { PutRemoveUnitVariablesRequest } from '../model/put-remove-unit-variables-request';
/**
 * VariablesApi - axios parameter creator
 * @export
 */
export const VariablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkImportVariables: async (postImportVariableRequest: PostImportVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postImportVariableRequest' is not null or undefined
            assertParamExists('checkImportVariables', 'postImportVariableRequest', postImportVariableRequest)
            const localVarPath = `/api/variables/import/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postImportVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostVariableRequest} postVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariable: async (postVariableRequest: PostVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postVariableRequest' is not null or undefined
            assertParamExists('createVariable', 'postVariableRequest', postVariableRequest)
            const localVarPath = `/api/variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitVariable: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUnitVariable', 'id', id)
            const localVarPath = `/api/variables/{id}/remove`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PutRemoveUnitVariablesRequest} requestParameters Request parameters. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitVariables: async (requestParameters: PutRemoveUnitVariablesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            const localVarPath = `/api/variables/remove/bulk`
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = requestParameters
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariable: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteVariable', 'id', id)
            const localVarPath = `/api/variables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
                /**
         * 
         * @param {PutRemoveUnitVariablesRequest} requestParameters Request parameters. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
                deleteVariables: async (requestParameters: PutRemoveUnitVariablesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
                    // verify required parameter 'id' is not null or undefined
                    const localVarPath = `/api/variables/delete/bulk`
                    // use dummy base URL string because the URL constructor only accepts absolute URLs.
                    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    let baseOptions;
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
        
                    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
                    const localVarHeaderParameter = {} as any;
                    const localVarQueryParameter = {} as any;
        
        
            
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
                    localVarRequestOptions.data = requestParameters
                    return {
                        url: toPathString(localVarUrlObj),
                        options: localVarRequestOptions,
                    };
                },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVariables: async (orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('exportVariables', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('exportVariables', 'orderDesc', orderDesc)
            const localVarPath = `/api/variables/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (controllerId !== undefined) {
                localVarQueryParameter['controllerId'] = controllerId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [type] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedVariables: async (keyword?: string, controllerId?: string, type?: string, locationId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/variables/unassigned/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (controllerId !== undefined) {
                localVarQueryParameter['controllerId'] = controllerId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByRpaId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVariablesByRpaId', 'id', id)
            const localVarPath = `/api/variables/rpa/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByTypeKeyword: async (limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getVariablesByTypeKeyword', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getVariablesByTypeKeyword', 'page', page)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getVariablesByTypeKeyword', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getVariablesByTypeKeyword', 'orderDesc', orderDesc)
            const localVarPath = `/api/variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (controllerId !== undefined) {
                localVarQueryParameter['controllerId'] = controllerId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVariablesByUnitId', 'id', id)
            const localVarPath = `/api/variables/unit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitIdForEquipment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVariablesByUnitIdForEquipment', 'id', id)
            const localVarPath = `/api/variables/get-unused/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitIdSoredOrder: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVariablesByUnitIdSoredOrder', 'id', id)
            const localVarPath = `/api/variables/unit-sorted-order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importVariables: async (postImportVariableRequest: PostImportVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postImportVariableRequest' is not null or undefined
            assertParamExists('importVariables', 'postImportVariableRequest', postImportVariableRequest)
            const localVarPath = `/api/variables/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postImportVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutVariableRequest} putVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariable: async (id: string, putVariableRequest: PutVariableRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVariable', 'id', id)
            // verify required parameter 'putVariableRequest' is not null or undefined
            assertParamExists('updateVariable', 'putVariableRequest', putVariableRequest)
            const localVarPath = `/api/variables/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putVariableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VariablesApi - functional programming interface
 * @export
 */
export const VariablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VariablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkImportVariables(postImportVariableRequest: PostImportVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkImportVariables(postImportVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostVariableRequest} postVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVariable(postVariableRequest: PostVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVariable(postVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnitVariable(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutRemoveVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnitVariable(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutRemoveUnitVariablesRequest} putRemoveUnitVariablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUnitVariables(putRemoveUnitVariablesRequest: PutRemoveUnitVariablesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutRemoveVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUnitVariables(putRemoveUnitVariablesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PutRemoveUnitVariablesRequest} putRemoveUnitVariablesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVariables(putRemoveUnitVariablesRequest: PutRemoveUnitVariablesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutRemoveVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVariables(putRemoveUnitVariablesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVariable(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVariable(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportVariables(orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExportVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportVariables(orderBy, orderDesc, keyword, controllerId, unitId, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [type] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnassignedVariables(keyword?: string, controllerId?: string, type?: string, locationId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnassignedVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnassignedVariables(keyword, controllerId, type, locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariablesByRpaId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariablesByRpaId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariablesByTypeKeyword(limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariablesByTypeKeyword(limit, page, orderBy, orderDesc, keyword, controllerId, unitId, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariablesByUnitId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariablesByUnitId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariablesByUnitIdForEquipment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariablesByUnitIdForEquipment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVariablesByUnitIdSoredOrder(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVariablesByUnitIdSoredOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importVariables(postImportVariableRequest: PostImportVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importVariables(postImportVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutVariableRequest} putVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVariable(id: string, putVariableRequest: PutVariableRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutVariableResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVariable(id, putVariableRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VariablesApi - factory interface
 * @export
 */
export const VariablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VariablesApiFp(configuration)
    return {
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkImportVariables(postImportVariableRequest: PostImportVariableRequest, options?: any): AxiosPromise<PostVariableResponse> {
            return localVarFp.checkImportVariables(postImportVariableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostVariableRequest} postVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVariable(postVariableRequest: PostVariableRequest, options?: any): AxiosPromise<PostVariableResponse> {
            return localVarFp.createVariable(postVariableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUnitVariable(id: string, options?: any): AxiosPromise<PutRemoveVariableResponse> {
            return localVarFp.deleteUnitVariable(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVariable(id: string, options?: any): AxiosPromise<DeleteVariableResponse> {
            return localVarFp.deleteVariable(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportVariables(orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options?: any): AxiosPromise<GetExportVariablesResponse> {
            return localVarFp.exportVariables(orderBy, orderDesc, keyword, controllerId, unitId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [type] 
         * @param {string} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnassignedVariables(keyword?: string, controllerId?: string, type?: string, locationId?: string, options?: any): AxiosPromise<GetUnassignedVariablesResponse> {
            return localVarFp.getUnassignedVariables(keyword, controllerId, type, locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByRpaId(id: string, options?: any): AxiosPromise<GetVariablesResponse> {
            return localVarFp.getVariablesByRpaId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {string} [keyword] 
         * @param {string} [controllerId] 
         * @param {string} [unitId] 
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByTypeKeyword(limit: number, page: number, orderBy: string, orderDesc: string, keyword?: string, controllerId?: string, unitId?: string, type?: string, options?: any): AxiosPromise<GetVariablesResponse> {
            return localVarFp.getVariablesByTypeKeyword(limit, page, orderBy, orderDesc, keyword, controllerId, unitId, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitId(id: string, options?: any): AxiosPromise<GetVariablesResponse> {
            return localVarFp.getVariablesByUnitId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitIdForEquipment(id: string, options?: any): AxiosPromise<GetVariablesResponse> {
            return localVarFp.getVariablesByUnitIdForEquipment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVariablesByUnitIdSoredOrder(id: string, options?: any): AxiosPromise<GetVariablesResponse> {
            return localVarFp.getVariablesByUnitIdSoredOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostImportVariableRequest} postImportVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importVariables(postImportVariableRequest: PostImportVariableRequest, options?: any): AxiosPromise<PostVariableResponse> {
            return localVarFp.importVariables(postImportVariableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutVariableRequest} putVariableRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVariable(id: string, putVariableRequest: PutVariableRequest, options?: any): AxiosPromise<PutVariableResponse> {
            return localVarFp.updateVariable(id, putVariableRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkImportVariables operation in VariablesApi.
 * @export
 * @interface VariablesApiCheckImportVariablesRequest
 */
export interface VariablesApiCheckImportVariablesRequest {
    /**
     * 
     * @type {PostImportVariableRequest}
     * @memberof VariablesApiCheckImportVariables
     */
    readonly postImportVariableRequest: PostImportVariableRequest
}

/**
 * Request parameters for createVariable operation in VariablesApi.
 * @export
 * @interface VariablesApiCreateVariableRequest
 */
export interface VariablesApiCreateVariableRequest {
    /**
     * 
     * @type {PostVariableRequest}
     * @memberof VariablesApiCreateVariable
     */
    readonly postVariableRequest: PostVariableRequest
}

/**
 * Request parameters for deleteUnitVariable operation in VariablesApi.
 * @export
 * @interface VariablesApiDeleteUnitVariableRequest
 */
export interface VariablesApiDeleteUnitVariableRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiDeleteUnitVariable
     */
    readonly id: string
}

/**
 * Request parameters for deleteVariable operation in VariablesApi.
 * @export
 * @interface VariablesApiDeleteVariableRequest
 */
export interface VariablesApiDeleteVariableRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiDeleteVariable
     */
    readonly id: string
}

/**
 * Request parameters for exportVariables operation in VariablesApi.
 * @export
 * @interface VariablesApiExportVariablesRequest
 */
export interface VariablesApiExportVariablesRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly orderDesc: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly controllerId?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly unitId?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiExportVariables
     */
    readonly type?: string
}

/**
 * Request parameters for getUnassignedVariables operation in VariablesApi.
 * @export
 * @interface VariablesApiGetUnassignedVariablesRequest
 */
export interface VariablesApiGetUnassignedVariablesRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetUnassignedVariables
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetUnassignedVariables
     */
    readonly controllerId?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetUnassignedVariables
     */
    readonly type?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetUnassignedVariables
     */
    readonly locationId?: string
}

/**
 * Request parameters for getVariablesByRpaId operation in VariablesApi.
 * @export
 * @interface VariablesApiGetVariablesByRpaIdRequest
 */
export interface VariablesApiGetVariablesByRpaIdRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByRpaId
     */
    readonly id: string
}

/**
 * Request parameters for getVariablesByTypeKeyword operation in VariablesApi.
 * @export
 * @interface VariablesApiGetVariablesByTypeKeywordRequest
 */
export interface VariablesApiGetVariablesByTypeKeywordRequest {
    /**
     * 
     * @type {number}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly orderDesc: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly controllerId?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly unitId?: string

    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByTypeKeyword
     */
    readonly type?: string
}

/**
 * Request parameters for getVariablesByUnitId operation in VariablesApi.
 * @export
 * @interface VariablesApiGetVariablesByUnitIdRequest
 */
export interface VariablesApiGetVariablesByUnitIdRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByUnitId
     */
    readonly id: string
}

/**
 * Request parameters for getVariablesByUnitIdForEquipment operation in VariablesApi.
 * @export
 * @interface VariablesApiGetVariablesByUnitIdForEquipmentRequest
 */
export interface VariablesApiGetVariablesByUnitIdForEquipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByUnitIdForEquipment
     */
    readonly id: string
}

/**
 * Request parameters for getVariablesByUnitIdSoredOrder operation in VariablesApi.
 * @export
 * @interface VariablesApiGetVariablesByUnitIdSoredOrderRequest
 */
export interface VariablesApiGetVariablesByUnitIdSoredOrderRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiGetVariablesByUnitIdSoredOrder
     */
    readonly id: string
}

/**
 * Request parameters for importVariables operation in VariablesApi.
 * @export
 * @interface VariablesApiImportVariablesRequest
 */
export interface VariablesApiImportVariablesRequest {
    /**
     * 
     * @type {PostImportVariableRequest}
     * @memberof VariablesApiImportVariables
     */
    readonly postImportVariableRequest: PostImportVariableRequest
}

/**
 * Request parameters for updateVariable operation in VariablesApi.
 * @export
 * @interface VariablesApiUpdateVariableRequest
 */
export interface VariablesApiUpdateVariableRequest {
    /**
     * 
     * @type {string}
     * @memberof VariablesApiUpdateVariable
     */
    readonly id: string

    /**
     * 
     * @type {PutVariableRequest}
     * @memberof VariablesApiUpdateVariable
     */
    readonly putVariableRequest: PutVariableRequest
}

/**
 * VariablesApi - object-oriented interface
 * @export
 * @class VariablesApi
 * @extends {BaseAPI}
 */
export class VariablesApi extends BaseAPI {
    /**
     * 
     * @param {VariablesApiCheckImportVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public checkImportVariables(requestParameters: VariablesApiCheckImportVariablesRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).checkImportVariables(requestParameters.postImportVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiCreateVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public createVariable(requestParameters: VariablesApiCreateVariableRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).createVariable(requestParameters.postVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiDeleteUnitVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public deleteUnitVariable(requestParameters: VariablesApiDeleteUnitVariableRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).deleteUnitVariable(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {PutRemoveUnitVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public deleteUnitVariables(requestParameters: PutRemoveUnitVariablesRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).deleteUnitVariables(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiDeleteVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public deleteVariable(requestParameters: VariablesApiDeleteVariableRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).deleteVariable(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PutRemoveUnitVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public deleteVariables(requestParameters: PutRemoveUnitVariablesRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).deleteVariables(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiExportVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public exportVariables(requestParameters: VariablesApiExportVariablesRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).exportVariables(requestParameters.orderBy, requestParameters.orderDesc, requestParameters.keyword, requestParameters.controllerId, requestParameters.unitId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetUnassignedVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getUnassignedVariables(requestParameters: VariablesApiGetUnassignedVariablesRequest = {}, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getUnassignedVariables(requestParameters.keyword, requestParameters.controllerId, requestParameters.type, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetVariablesByRpaIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getVariablesByRpaId(requestParameters: VariablesApiGetVariablesByRpaIdRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getVariablesByRpaId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetVariablesByTypeKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getVariablesByTypeKeyword(requestParameters: VariablesApiGetVariablesByTypeKeywordRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getVariablesByTypeKeyword(requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.keyword, requestParameters.controllerId, requestParameters.unitId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetVariablesByUnitIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getVariablesByUnitId(requestParameters: VariablesApiGetVariablesByUnitIdRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getVariablesByUnitId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetVariablesByUnitIdForEquipmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getVariablesByUnitIdForEquipment(requestParameters: VariablesApiGetVariablesByUnitIdForEquipmentRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getVariablesByUnitIdForEquipment(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiGetVariablesByUnitIdSoredOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public getVariablesByUnitIdSoredOrder(requestParameters: VariablesApiGetVariablesByUnitIdSoredOrderRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).getVariablesByUnitIdSoredOrder(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiImportVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public importVariables(requestParameters: VariablesApiImportVariablesRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).importVariables(requestParameters.postImportVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {VariablesApiUpdateVariableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VariablesApi
     */
    public updateVariable(requestParameters: VariablesApiUpdateVariableRequest, options?: AxiosRequestConfig) {
        return VariablesApiFp(this.configuration).updateVariable(requestParameters.id, requestParameters.putVariableRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
